import { Stack } from '@mui/material';
import { StreamingIndicator, type StreamingIndicatorProps } from '@mui/x-chat/headless';

import { isDefined } from 'common';

import { AgenticChatActivityIcon } from './Icon';
import { isAgenticChatActivityPart, isAgenticChatActivityPartVisible } from './isVisiblePart';

export function AgenticChatWorkingIndicator(props: StreamingIndicatorProps) {
  const { message } = props;
  if (isDefined(message) && message.status === 'streaming') {
    for (let index = message.parts.length - 1; index >= 0; index -= 1) {
      const part = message.parts[index];
      if (!isAgenticChatActivityPart(part)) {
        break;
      }
      if (isAgenticChatActivityPartVisible({ part, message, index })) {
        return null;
      }
    }
  }
  return (
    <StreamingIndicator {...props}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          minHeight: (theme) => theme.spacing(3),
          typography: 'body2',
        }}
      >
        <AgenticChatActivityIcon animation="Active" />
      </Stack>
    </StreamingIndicator>
  );
}
